const prefix = 'language/'

const type = {
    CHANGE_LANGUAGE: prefix + 'changeLang',
}

const action = {
    changeLanguage: language => {
        return {
            type: type.CHANGE_LANGUAGE,
            payload: {
                language,
            },
        }
    },
}

export default {
    type,
    action,
}
